<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { getOrderUrl, getDepositUrl, getBenefitsUrl } from '@/helpers'
import { SUPPORT_PORTAL_LINK_URL, GAMES } from '@/constants'
import settings from '@/settings'

@Component
class AboutCardBase extends Vue {
  @Prop({ type: String, required: true }) game
  @Prop({ type: String }) partner
  @State('country') currentCountry
  @State('designs') designs

  get depositLink () {
    const href = getDepositUrl(this.partner)
    return this.getLinks(href, '_blank')
  }

  get bindLink () {
    const href = this.$router.resolve({ name: 'bind' }).href
    return this.getLinks(href)
  }

  get orderLink () {
    const href = getOrderUrl(this.currentCountry, this.game)
    return this.getLinks(href)
  }

  get orderLinkBY () {
    const href = settings.get(['CARD_ORDER_URL_BY', this.game.toUpperCase()])

    return this.getLinks(href)
  }

  get benefitsLink () {
    const href = getBenefitsUrl(this.currentCountry)
    return this.getLinks(href, '_blank')
  }

  get design () {
    try {
      return this.designs[this.partner][this.game][0]
    } catch {
      return null
    }
  }

  get games () {
    return GAMES
  }

  getLinks (href, target = '') {
    return {
      linkStart: `<a class="link" href="${href}" target="${target}">`,
      linkStop: '</a>'
    }
  }

  trackToogleAdditionalFutureList () {
    this.$analytics.trackAdditionalFuturesHistoryPage({ game: this.game, screenId: this.$route.name })
  }

  getLearnMoreUrl (game) {
    return `${SUPPORT_PORTAL_LINK_URL}products/${game}/article/14998/`
  }
}

export default AboutCardBase
</script>
